<template>
    <div>
        <primer-payment-method-form v-if="isDEU || isNLD"  :submitButtonText="submitButtonText || $t('PRIMER_CARD_CONFIRM')" :orderValue="orderValue" :hideCard="true"/>
        <stripe-payment-request-button v-if="showPaymentRequestButton" :setupIntent="setupIntent" :isUpdate="true" @closed="close" @updateCard="updatePaymentSource"/>

        <stripe-elements-form
            ref="cardForm"
            :full-name.sync="cardFullName"
            :billing-address="billingAddress"
            :has-been-requested="false"/>
        <p class="error my-2" v-text="error" v-if="error"></p>

        <div class="w-full flex">
            <div class="w-full md:w-1/2 p-2">
                <button
                    class="btn btn--primary btn--full-width btn--auto-width"
                    :disabled="processing"
                    @click="updateCustomersCard">
                    {{$t('EDIT_BILLING_ADDRESS_FORM_BTN_UPDATE')}}
                </button>
            </div>
            <div class="w-full md:w-1/2 p-2">
                <button class="btn btn--secondary btn--full-width btn--auto-width"
                        :disabled="processing"
                        @click="close">
                    {{$t('EDIT_BILLING_ADDRESS_FORM_BTN_CANCEL')}}
                </button>
            </div>
        </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PaymentService from '@/services/payments/PaymentService';
import StripeElementsForm from '@/components/forms/cardDetails/StripeElementsForm';
import StripePaymentRequestButton from '../cardDetails/StripePaymentRequestButton';
import PrimerPaymentMethodForm from '@/components/forms/cardDetails/PrimerPaymentMethodForm';

let paymentService = new PaymentService();

export default {
    name: 'EditCardDetailsForm',
    components: {
        PrimerPaymentMethodForm,
        StripeElementsForm,
        StripePaymentRequestButton,
    },
    props: {
        autoClose: {
            default: false,
            type: Boolean,
        },
        orderValue: {
            required: true,
        },
        submitButtonText: {
            default: null,
            type: String,
        },
    },
    data() {
        return {
            error: null,
            cardToken: null,
            cardFullName: null,
            cardTokenRequested: false,
            processing: false,
            sameCard: false,
        };
    },
    created() {
        this.cardFullName = this.fullName;
        this.is3DSEnabled && this.fetchStripeSetupIntent({ email: this.email, gateway: this.paymentGateway });
    },
    methods: {
        ...mapActions({
            fetchStripeSetupIntent: 'account/fetchStripeSetupIntent',
        }),
        close() {
            this.$emit('closed');
            this.$emit('same-card-toggle');
        },
        toggleProcessing() {
            this.processing = !this.processing;
        },
        updateCustomersCard() {
            // Send via API using service
            this.error = null;

            this.toggleProcessing();

            if (this.is3DSEnabled) {
                this.$refs.cardForm.handleScaCardSubmission()
                    .then(tokenData => {
                        let payload = {
                            card_token: tokenData.setupIntentId,
                            stripe_card_id: tokenData.setupIntentId,
                            payment_method: 'card',
                            gateway: this.paymentGateway,
                            name_on_card: this.cardFullName,
                        };
                        this.updatePaymentSource(this.userId, payload);
                        this.$emit('new-card-token', tokenData?.setupIntent?.payment_method);
                    })
                    .catch((err) => {
                        this.error = err;
                        this.handleFail();
                    });
            } else {
                this.$refs.cardForm.handleFetchingToken()
                    .then(tokenData => {
                        let payload = {
                            card_token: tokenData.tokenId,
                            stripe_card_id: tokenData.cardId,
                            payment_method: 'card',
                            gateway: this.paymentGateway,
                            name_on_card: this.cardFullName,
                        };
                        this.updatePaymentSource(this.userId, payload);
                    })
                    .catch(() => {
                        this.handleFail();
                    });
            }
        },
        updatePaymentSource(userId, payload) {
            paymentService.updatePaymentSource(userId, payload)
                .then(() => {
                    this.$store.dispatch('account/fetchUserData', true);
                    this.close();
                })
                .catch(error => {
                    this.toggleProcessing();
                    this.$store.commit('account/setSetupIntent', null);
                    this.fetchStripeSetupIntent({ email: this.email, gateway: this.paymentGateway });
                    const hasAmex = error.response?.data?.errors.error[0].includes('Amex');
                    if (hasAmex) return this.error = this.$t('AMERICAN_EXPRESS_NOT_SUPPORTED');
                    this.error = error.response.data.error;
                });
        },
        handleFail() {
            this.processing = false;
            this.$scrollTo(`.input--invalid`, {
                offset: -100,
            });
        },
    },
    computed: {
        ...mapGetters({
            billingAddress: 'payment/getBillingAddress',
            userId: 'account/getUserId',
            fullName: 'account/getFullName',
            isDEU: 'localisation/isDEU',
            isNLD: 'localisation/isNLD',
            email: 'account/getEmail',
            setupIntent: 'account/getSetupIntent',
            is3DSEnabled: 'payment/is3DSEnabled',
            paymentGateway: 'payment/getStripeGateway',
        }),
        showPaymentRequestButton() {
            return this.is3DSEnabled && this.setupIntent;
        },
    },
    watch: {
        cardToken: {
            handler: function(cardToken) {
                if (cardToken && cardToken.id) this.updateCustomersCard();
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
    .cancel-button {
        max-width: 440px;
    }
</style>
